import { PropsWithChildren } from "react";
import { GetUserStore } from "SessionState/User/UserStore";
import { observer } from "mobx-react";
import { GetContestantStore } from "SessionState/Contestant/ContestantStore";
import { GetPageantStore } from "SessionState/Pageant/PageantStore";
import { EventModel } from "API/Generated/data-contracts";




export const BetaWrapper = observer((props: PropsWithChildren) => {
    const userStore = GetUserStore();
  
    
    if (userStore.CurrentUser?.betaUser) {
        return <>{props.children}</>   
    }
    return (null)
})

export const ProMemberWrapper = observer((props: PropsWithChildren) => {
    const userStore = GetUserStore();
    
    if (userStore.CurrentUser?.roles?.includes("Director")) {
        return (<>{props.children}</>)    
    }
    return (null)
})

export const AdminOnlyWrapper = observer((props: PropsWithChildren) => {
  const userStore = GetUserStore();
  
  if (userStore.CurrentUser?.roles?.includes("Admin")) {
      return (<>{props.children}</>)    
  }
  return (null)
})

export const LimitedVisiblityWrapper = observer((props: PropsWithChildren) => {
    const userStore = GetUserStore();
    const contestantStore = GetContestantStore();
    
    if (userStore.CurrentUser?.id != contestantStore.CurrentContestant.userId) {
        return (<>{props.children}</>)    
    }
    return (null)
})

interface MembershipWrapperProps {
  allowedRoles: string[];
  show?: React.ReactNode;
}

export const MembershipWrapper = observer((props: PropsWithChildren<MembershipWrapperProps>) => {
  const userStore = GetUserStore();

  if (userStore.CurrentUser?.roles?.some(role => props.allowedRoles.includes(role))) {
    return <>{props.children}</>;
  }

  return props.show ? <>{props.show}</> : null;
});

  interface BlockFromUIWrapperProps {
    ifDirectorIsRole: string[];
    show?: React.ReactNode;
  }
  
  export const BlockFromUIWrapper = observer((props: PropsWithChildren<BlockFromUIWrapperProps>) => {
    const userStore = GetUserStore();
    const pageantStore = GetPageantStore();
  
    const { ifDirectorIsRole, show, children } = props;
  
    const eventDirectorRoles = pageantStore?.CurrentPageant?.event?.director?.user?.roles
      ?.some((role) => ifDirectorIsRole.includes(role)) ?? false;
  
    return eventDirectorRoles ? <>{show}</> : <>{children}</>;
  });

  
  interface BlockFromUIWrapper2Props {
    show: React.ReactNode;
    ifDirectorIsRole: string[];
    pageantStore?: ReturnType<typeof GetPageantStore>; // Add pageantStore prop
    eventModel?: EventModel; // Add eventModel prop
  }

  export const BlockFromUIWrapper2 = observer(
    (props: PropsWithChildren<BlockFromUIWrapper2Props>) => {
      const { show, ifDirectorIsRole, pageantStore, eventModel, children } = props;
     
      // Perform the role checking based on the presence of pageantStore or eventModel
      const eventDirectorRoles = pageantStore
        ? pageantStore?.CurrentPageant?.event?.director?.user?.roles
            ?.some((role) => ifDirectorIsRole.includes(role)) ?? false
        : eventModel?.director?.user?.roles
            ?.some((role) => ifDirectorIsRole.includes(role)) ?? false;
  
      return eventDirectorRoles ? <>{show}</> : <>{children}</>;
    }
  );

  interface BlockFromCurrentUserWrapperProps {
    ifCurrentUserIsRole: string[];
    fallback?: React.ReactNode;
  }
  
  export const BlockFromCurrentUserWrapper = observer((props: PropsWithChildren<BlockFromCurrentUserWrapperProps>) => {
    const userStore = GetUserStore();
    const pageantStore = GetPageantStore();
  
    const { ifCurrentUserIsRole, fallback, children } = props;
  
    const currentUserRoles = userStore.CurrentUser?.roles
      ?.some((role) => ifCurrentUserIsRole.includes(role)) ?? false;
  
    return currentUserRoles ? <>{fallback}</> : <>{children}</>;
  });

  export const BlockFromMiniDirectorMembershipWrapper = observer((props: PropsWithChildren) => {
    const userStore = GetUserStore();
    const pageantStore = GetPageantStore();
    
    if (userStore.CurrentUser?.roles?.includes("MiniDirectorMember")) {
      return (null)
    }
    else{
    return <>{props.children}</>
    }
})

export const AdminBlockFromOthersWrapper = observer((props: PropsWithChildren) => {
  const userStore = GetUserStore();
  const pageantStore = GetPageantStore();
  
  if (pageantStore?.CurrentPageant?.event?.director?.user?.roles?.includes("Admin") ) {
    return (null)
  }
  else{
  return <>{props.children}</>
  }
})

export const MiniDirectorOfEventBlockFromOthersMembershipWrapper = observer((props: PropsWithChildren) => {
  const userStore = GetUserStore();
  const pageantStore = GetPageantStore();
  
  if (pageantStore?.CurrentPageant?.event?.director?.user?.roles?.includes("MiniDirectorMember") ) {
    return (null)
  }
  else{
  return <>{props.children}</>
  }
})

  interface EventDirectorMembershipWrapperProps {
    eventDirectorRoles: string[] | null | undefined; // Allow null in addition to string[]
    allowedRoles: string[]; // Roles that are allowed to see the components
  }
  
  export const EventDirectorMembershipWrapper = observer(
    (props: PropsWithChildren<EventDirectorMembershipWrapperProps>) => {
      const { eventDirectorRoles, allowedRoles, children } = props;
      console.log('Event director has required roles:', eventDirectorRoles);
      // Check if eventDirectorRoles is not null or undefined and has at least one allowed role
      if (
        eventDirectorRoles &&
        allowedRoles.some(role => eventDirectorRoles.includes(role))
      ) {
        return <>{children}</>;
      }
  
      return null;
    }
  );